import updateSettingsModalTemplate from "../../views/update-settings-modal.tpl.html";
import UpdateSettingsModalController from '../../controllers/update-settings-modal-controller'

class UpdateShippingSettingsWorkflow {
    constructor($injector, $state) {
        this.injector = $injector;
        this.state = $state;
        this.uibModal = $injector.get('$uibModal');

        this.key = `update-shipping-settings`;
        this.title = 'Edit Settings';
        this.level = 'highlight';
        this.icon = 'cog';
        this.order = 10;
    }

    action(payload, store) {
        this.startEditSettingsModal()
    }

    startEditSettingsModal() {
        return this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: updateSettingsModalTemplate,
            size: 'lg',
            controller: UpdateSettingsModalController,
            controllerAs: 'vm',
            resolve: {
                shipping: this.shipping
            }
        });
    }
}

angular
    .module('festzelt-os.shippings')
    .factory('updateShippingSettings', [
        '$injector',
        '$state',
        ($injector, $state) => new UpdateShippingSettingsWorkflow($injector, $state)
    ])



// WEBPACK FOOTER //
// ./src/app/pages/shippings/workflows/list/update-shipping-settings.js